import { useSiteUserTraits } from '@confluence/targeting/entry-points/useSiteUserTraits.ts';

export const TEMPLATE_XFLOW_REMINDER_TRAIT_KEY = 'twc_xflow_conf_meeting_pages_templates_reminder';
export const TEMPLATE_XFLOW_REMINDER_TRAIT_VALUE = 'remind';
export const TEMPLATE_XFLOW_DISMISSED_TRAIT_VALUE = 'dismissed';

export type TemplateXflowReminderTapTraitState =
	| typeof TEMPLATE_XFLOW_REMINDER_TRAIT_VALUE
	| typeof TEMPLATE_XFLOW_DISMISSED_TRAIT_VALUE
	| 'absent'
	| 'loading'
	| 'error'
	| 'unexpected';

export type TemplateXflowReminderTapTrait = {
	reminder: TemplateXflowReminderTapTraitState;
	error: Error | null;
};

export const useTemplateXflowReminderTapTrait = ({
	enabled,
}: {
	enabled: boolean;
}): TemplateXflowReminderTapTrait => {
	const { data, loading, error } = useSiteUserTraits({
		skip: !enabled,
	});

	if (!enabled) {
		return { reminder: 'absent', error: null };
	}

	if (loading) {
		return { reminder: 'loading', error: null };
	}

	if (error) {
		return { reminder: 'error', error };
	}

	const reminder = data?.attributes?.find(({ name }) => name === TEMPLATE_XFLOW_REMINDER_TRAIT_KEY);

	const reminderValue = reminder?.value;

	return {
		reminder:
			reminderValue === TEMPLATE_XFLOW_REMINDER_TRAIT_VALUE ||
			reminderValue === TEMPLATE_XFLOW_DISMISSED_TRAIT_VALUE
				? reminderValue
				: reminder
					? 'unexpected'
					: 'absent',
		error: null,
	};
};
